import React, { useState, useEffect } from "react";
import JourneyMapEnglish from "../../../assets/HomeSection/journey-map-english.png";
import JourneyMapTamil from "../../../assets/HomeSection/journey-map-tamil.png";
import JourneyMapSinhala from "../../../assets/HomeSection/journey-map-sinhala.png";
import "./YourJourney.css";
import "./../typography-home.css";
import { useSelector } from "react-redux";
import {
  englishData,
  sinhalaData,
  tamilData,
} from "../../../dummyData/HomeDummyData";

function YourJourney() {
  const selectedLanguage = useSelector((state) => state.language.language);
  const [language, setLanguage] = useState(sinhalaData[0]);
  const [journeyImage, setJourneyImage] = useState(JourneyMapSinhala);

  useEffect(() => {
    switch (selectedLanguage.value) {
      case "english":
        setLanguage(englishData[0]);
        setJourneyImage(JourneyMapEnglish);
        break;
      case "tamil":
        setLanguage(tamilData[0]);
        setJourneyImage(JourneyMapTamil);
        break;
      default:
        setLanguage(sinhalaData[0]);
        setJourneyImage(JourneyMapSinhala);
        break;
    }

  }, [selectedLanguage]);
  return (
    <section className="lesson-section py-5 min-vh-75 d-flex align-items-center">
      <div className="container">
        <h2 className="typography-title fw-bold mb-4">{language.StepsTitle}</h2>

        <div className="journey-image-wrapper mx-auto shadow-lg p-3 rounded-4">
          <img
            src={journeyImage}
            alt="How to get a driving license in Sri Lanka"
            className="img-fluid rounded-4"
            loading="lazy"
          />
        </div>
      </div>
    </section>
  );
}

export default YourJourney;
